// extracted by mini-css-extract-plugin
export var activityContainer = "_mg-0";
export var typingIndicatorContainer = "_mg-1";
export var typingIndicatorDot = "_mg-2";
export var wave = "_mg-3";